import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as0008',
    ecrans: ['00-2'],
    params: ['id',
             '?asgcleint',
             '?flginfor',
             '?flg',
             '?flgman',
             '?flgdal']
});
